module.exports = __webpack_public_path__ + "static/media/01C.09c00e08.png";